import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addannounce from "./components/addannounce";
export default {
  name: "announceList",
  mixins: [loadMoreList, serchSelect],
  components: {
    addannounce: addannounce
  },
  data: function data() {
    return {
      pagingReqFn: "Announce",
      pagingReqValue: "data",
      paramsData: {
        id: '',
        language: '',
        title: '',
        type_id: '',
        content: '',
        author: '',
        top: '',
        state: '0',
        game_type: '',
        top_all: true,
        state_all: true
      },
      announceTypeList: [],
      drawer: false,
      content: '',
      delIds: [],
      state: [{
        label: '全部',
        value: '0'
      }, {
        label: '启用',
        value: 1
      }, {
        label: '禁用',
        value: 2
      }],
      top: [{
        label: '全部',
        value: ''
      }, {
        label: '置顶',
        value: 1
      }, {
        label: '不置顶',
        value: 0
      }],
      tableBody: 'announceListTable',
      sortReq: 'announceChangeSort'
    };
  },
  activated: function activated() {
    var _this = this;

    this.getList();
    this.$api.announceTypeList({
      id: 1
    }).then(function (res) {
      if (res.code == 0) {
        _this.announceTypeList = res.data;
      }
    });
  },
  watch: {
    'paramsData.state': function paramsDataState(newVal) {
      this.paramsData.state_all = newVal === '1' ? true : false;
    },
    'paramsData.top': function paramsDataTop(newVal) {
      this.paramsData.top_all = newVal === '1' ? true : false;
    },
    deep: true
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    viewOpen: function viewOpen(content) {
      this.content = this.$utils.textRepl(content);
      this.drawer = true;
    },
    del: function del(dateList) {
      var _this2 = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delAnnounce',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this2.getList();
      });
    }
  }
};